import { Draggable } from "react-beautiful-dnd";
import { GripVertical } from "lucide-react";
import { cn } from "@/lib/utils";

interface DraggableKPICardProps {
  id: string;
  index: number;
  children: React.ReactNode;
  isEditMode?: boolean;
}

export const DraggableKPICard = ({ id, index, children, isEditMode = false }: DraggableKPICardProps) => {
  return (
    <Draggable draggableId={id} index={index} isDragDisabled={!isEditMode}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={cn(
            "relative transition-all duration-200",
            isEditMode && "cursor-grab active:cursor-grabbing",
            isEditMode && !snapshot.isDragging && "ring-2 ring-primary/30 ring-offset-2 ring-offset-background rounded-xl",
            snapshot.isDragging && "z-50 rotate-2 scale-105 shadow-2xl ring-2 ring-primary"
          )}
        >
          {/* Edit Mode Indicator */}
          {isEditMode && (
            <div
              className={cn(
                "absolute -top-2 -left-2 z-10 p-1.5 rounded-full bg-primary text-primary-foreground shadow-lg",
                "flex items-center justify-center",
                snapshot.isDragging && "scale-110"
              )}
            >
              <GripVertical className="h-3 w-3" />
            </div>
          )}
          {children}
        </div>
      )}
    </Draggable>
  );
};
